import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询设计项目列表
export const queryAcceptancePages: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAcceptancePages', { ...state.acceptancePage, loading: true });
    const res: IPageData = await $http.post('/v1/design/acceptance/list', payload);
    const { list: data, total, pageNum, pageSize } = res;
    commit('setAcceptancePages', { data, total, pageNum, pageSize });
  } catch (e) {
    commit('setAcceptancePages', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 查询设计项目详情
export const queryAcceptanceDetail: IActionFn<IModuleState> = async ({ commit }, id) => {
  try {
    commit('setAcceptanceDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/design/acceptance/${id}/detail`);
    commit('setAcceptanceDetail', { data: res });
  } catch (e) {
    commit('setAcceptanceDetail', { data: null });
  }
};

// 查询设计项目操作日志
export const queryAcceptanceLogs: IActionFn<IModuleState> = async ({ commit, state }, id) => {
  try {
    commit('setAcceptanceLogs', { ...state.acceptanceLogs, loading: true });
    const res = await $http.get(`/v1/data/design/acceptance/${id}/detaillog`);
    commit('setAcceptanceLogs', { data: res || [] });
  } catch (e) {
    commit('setAcceptanceLogs', { data: [] });
  }
};

// 创建设计项目
export const addAcceptance: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await $http.post('/v1/design/acceptance/appointment', payload);
    store.commit('common/setToast', { visible: true, text: '创建成功' });
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 编辑设计项目
export const editAcceptance: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/design/acceptance/modifyinspectiondetail', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 通过设计项目
export const completeAcceptance: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/design/acceptance/accept', payload);
    store.commit('common/setToast', { visible: true, text: '通过成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 终止设计项目
export const stopAcceptance: IActionFn<IModuleState> = async ({ commit, state }, id) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/design/acceptance/accept', { id });
    store.commit('common/setToast', { visible: true, text: '终止成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 删除设计项目
export const deleteAcceptance: IActionFn<IModuleState> = async ({ commit, state }, id) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/design/acceptance/deleteappointment', { id });
    store.commit('common/setToast', { visible: true, text: '删除成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 查询状态字典
export const queryAcceptanceStatus: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setAcceptanceStatus', { ...state.acceptanceStatus, loading: true });
    const res = await $http.get('/common/chooseoptions/InspectionOperationStatus');
    commit('setAcceptanceStatus', { data: res, raw: res });
  } catch (e) {
    commit('setAcceptanceStatus', { data: [], raw: [] });
  }
};

// 查询专案组的反馈列表
export const queryFeedbackList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setFeedbackList', { ...state.feedbackList, loading: true });
    const res = await $http.post('/v1/design/acceptance/note/list', payload);
    commit('setFeedbackList', { data: res });
  } catch (e) {
    commit('setFeedbackList', { data: [] });
  }
};

// 增加反馈信息
export const addFeedback: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const params = { location: 'X=-1 Y=-1 Z=-1', rotation: 'X=-1 Y=-1 Z=-1', ...payload };
    const ignores = { ignoreCode: [4001] };
    commit('setDialog', { ...state.dialog, loading: true });
    const res: any = await $http.post('/v1/design/acceptance/addnote', params, ignores);
    if (res?.rtnCode === 4001) {
      const errMsg = '专案组未找到，请检查专案组是否已经从该项目中删除！';
      store.commit('common/setToast', { visible: true, text: errMsg });
    } else {
      store.commit('common/setToast', { visible: true, text: '添加成功' });
    }
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 删除反馈信息
export const deleteFeedback: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await $http.post('/v1/design/acceptance/deletenote', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 完成反馈信息
export const closeFeedback: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await $http.post('/v1/design/acceptance/closenote', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};
